import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Login from "@/pages/Login";
import Signup from "@/pages/Signup";
import Layout from "@/pages/Layout";
import Dashboard from "@/pages/Dashboard";
import ManageUsers from "@/pages/ManageUsers";
import AddUser from "@/pages/AddUser";
import Settings from "@/pages/Settings";
import SettingsIntro from "@/pages/SettingsIntro";
import SettingSubpage from "@/pages/SettingSubpage";
import { Toaster } from "@/components/ui/sonner";
import { Loader2 } from "lucide-react";

function AppRoutes() {
  const { user } = useAuth();

  if (user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-white">
        <Loader2 className="animate-spin text-[#13B5EA]" size={32} />
      </div>
    );
  }

  return (
    <Routes>
      <Route path="/login" element={user ? <Navigate to="/" replace /> : <Login />} />
      <Route path="/signup" element={user ? <Navigate to="/" replace /> : <Signup />} />
      <Route path="/" element={user ? <Layout /> : <Navigate to="/login" replace />}>
        <Route index element={<Dashboard />} />
        <Route path="pay-runs" element={<Dashboard />} />
        <Route path="filing" element={<Dashboard />} />
        <Route path="reports" element={<Dashboard />} />
        <Route path="approval" element={<Dashboard />} />
        <Route path="settings" element={<Settings />}>
          <Route index element={<SettingsIntro />} />
          <Route path=":slug" element={<SettingSubpage />} />
        </Route>
        <Route path="manage-users" element={<ManageUsers />} />
        <Route path="manage-users/add" element={<AddUser />} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <AppRoutes />
          <Toaster position="top-right" richColors />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
